import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Settings2, Loader2 } from "lucide-react";

const LABEL = { monthly: "$12.99 / month", yearly: "$99 / year" };

export default function PlanManager() {
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/payments/subscription").then((r) => setSub(r.data)).catch(() => {});
  }, []);

  const openPortal = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/portal", { origin_url: window.location.origin });
      window.location.href = data.portal_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't open billing portal");
      setLoading(false);
    }
  };

  const renews = sub?.current_period_end ? new Date(sub.current_period_end).toLocaleDateString() : null;

  return (
    <div className="mt-4" data-testid="plan-manager">
      <div className="font-mono text-[10px] uppercase tracking-widest text-[#00E676] bg-[#00E676]/10 border border-[#00E676]/30 rounded-sm px-2 py-2 text-center" data-testid="plan-manager-badge">
        CLAWBACK MEMBER · {sub?.plan ? sub.plan.toUpperCase() : "ACTIVE"}
      </div>
      <div className="mt-2 flex items-center justify-between gap-2 text-xs text-[#A0A7B0]">
        <span data-testid="plan-manager-detail">
          {sub?.plan ? LABEL[sub.plan] : "Membership active"}
          {renews && (sub.cancel_at_period_end ? ` · ends ${renews}` : ` · renews ${renews}`)}
        </span>
        <button onClick={openPortal} disabled={loading} className="flex items-center gap-1 text-[#F4F1EA] hover:text-[#00E676] transition-colors shrink-0" data-testid="plan-manage-button">
          {loading ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Settings2 className="h-3.5 w-3.5" />}
          {sub?.plan === "monthly" ? "Switch to yearly · save $57" : "Manage plan"}
        </button>
      </div>
      {sub?.cancel_at_period_end && (
        <div className="mt-2 text-[11px] text-[#FFC857]" data-testid="plan-cancel-notice">Cancellation scheduled — you keep access until {renews}.</div>
      )}
    </div>
  );
}
